// 약관·방침 v3 첫 로그인 안내 페이지 문안 (시안 C1 「문서형」 — 대표 선택 2026-09-09)
// 시안: docs/design/legal-v3-creator-pc-variants.html (C1) · 모바일 docs/design/legal-v3-creator-variants.html (C)
// 원칙: 「왜 필요한가 → 무엇이 보장되나 → 선택할 수 있다」 순서. 명령형·당연시 표현 없음(대표 지시).
// 조문 번호는 게시 원고 docs/ops/policy/published/terms-v3.md 와 맞춘다.

import { formatKrw } from "./tierPricing";

export const LEGAL_NOTICE_HEAD = {
  kicker: "2026. 10. 31. 시행",
  title: "이용약관이 새로워졌어요",
  lead:
    "레이블리는 권리사·크리에이터와 함께 작품을 안전하게 쓰기 위한 협업의 약속, 지금 운영하는 그대로의 정산 기준, 11월부터 시작하는 멤버십 구독료와 개인정보 처리 내용을 담아 이용약관과 개인정보처리방침을 새로 정리했습니다.",
  readTime: "읽는 데 약 3분 · 동의는 아래 바에서",
};

/**
 * 섹션 목록. variant: "creator" | "partner"(제휴·마케팅 파트너 — 계약이 우선, 약관은 사이트 이용 규칙) | "rights"(권리사 — 현재 게이트 대상 아님, 문안만 보존)
 * fee: { tier, monthlyFee } | null — 크리에이터의 등급·멤버십 구독료(등급제 안내 상태에서). 없으면 요금표 문장으로.
 */
export function buildLegalNoticeSections({ variant = "creator", fee = null } = {}) {
  const isCreator = variant === "creator";
  const isPartner = variant === "partner";
  const feeLine = fee && fee.monthlyFee > 0
    ? `${fee.tier || "내 등급"} · 월 ${formatKrw(fee.monthlyFee)} · 11월 1일 첫 결제`
    : "실버 199,000 · 골드 99,000 · 플래티넘 55,000 · 다이아몬드 이상 0원 (부가가치세 포함)";

  const sections = [
    {
      id: "rights",
      no: "①",
      title: "협업의 약속",
      chip: "약관 제5조의2",
      why: isPartner
        ? "파트너님이 소개한 크리에이터가 만드는 콘텐츠는 권리사의 작품·크리에이터의 편집·레이블리의 협업 구조가 함께 만든 결과물입니다. 그 콘텐츠의 저작재산권은 권리사에게 귀속되고, 크리에이터에게는 게시·수익 배분이 보장됩니다. 파트너님은 모집·영업 과정에서 이 약속과 어긋나는 안내(「판권을 산다」「저작권을 넘긴다」 등)를 하지 않습니다."
        : isCreator
        ? "작품은 권리사가 오랜 시간과 비용을 들여 만든 것이고, 콘텐츠는 권리사의 작품·크리에이터님의 편집·레이블리의 협업 구조가 함께 만든 결과물입니다. 출연자·방송사·플랫폼과의 관계에서 권리사가 콘텐츠를 직접 책임질 수 있어야 크리에이터님을 보호할 수 있습니다."
        : "작품은 권리사의 것이고, 크리에이터가 작품으로 만든 콘텐츠의 저작재산권도 권리사에게 귀속됩니다. 회사는 권리사와의 협약 범위 안에서만 작품을 크리에이터에게 제공합니다.",
      body: isCreator ? "그래서 작품으로 만든 콘텐츠의 저작재산권은 권리사에게 귀속됩니다. 지금까지 만든 콘텐츠에도 같은 약속과 같은 보장이 적용되며, 그동안 받으신 수익 배분이 그 대가입니다(부칙 5)." : null,
      listTitle: isPartner ? "파트너님과 관련된 것" : (isCreator ? "크리에이터님께 남는 것" : "권리사에게 보장되는 것"),
      list: isPartner
        ? [
            "파트너 계약(부속서 포함)이 이 약관보다 우선합니다 — 수익 쉐어·정산 규칙은 계약서의 값",
            "약관은 사이트 이용 규칙(계정·통지·개인정보·권리 침해 신고)으로 적용됩니다",
            "모집·홍보에서 지켜야 할 표현 규칙은 파트너 가이드에 따릅니다",
          ]
        : isCreator
        ? [
            "신청한 채널에 게시하고 유지할 권리, 수익 배분",
            "채널명 표시와 명예 존중 — 회사와 권리사가 지는 약속",
            "직접 촬영·녹음한 영상, 자체 제작한 자막·그래픽은 내 것",
            "작품마다 동의 여부를 고를 수 있고, 동의하지 않아도 불이익 없음",
          ]
        : [
            "삭제·비공개 요청권(제13조)과 검수·공개 시점 통제(제12조)",
            "권리 침해 신고 창구(제13조의2) — 저작권법 제103조 절차",
            "협업 채널의 게시 영상·조회수·정산 대상 수치 열람(개인정보처리방침 제5장)",
          ],
    },
    {
      id: "settlement",
      no: "②",
      title: "정산은 그대로",
      chip: "제27·28조",
      kv: [
        { k: "정산일", v: "매월 25일 · 수익이 난 달의 두 달 뒤 — 지금과 같습니다" },
        { k: "새로 생김", v: "보류 상한 60일 · 이의 제기 30일 — 크리에이터에게 유리한 쪽" },
        { k: "세금", v: "개인 3.3% 원천징수 · 사업자 세금계산서 — 지금과 같습니다" },
      ],
    },
  ];

  if (isCreator) {
    sections.push({
      id: "paid",
      no: "③",
      title: "11월 1일부터 멤버십 구독료",
      chip: "제16~26조",
      kv: [
        { k: "내 경우", v: feeLine, strong: true },
        { k: "환불", v: "결제 7일 안 미이용이면 전액 · 즉시 종료(중도해지)도 가능" },
        { k: "해지", v: "설정 › 멤버십에서 언제든지 · 다음 결제일부터 청구 없음" },
        { k: "휴면", v: "90일 동안 작품 영상이 없으면 휴면 · 다시 시작할 때 재활성화비 150,000원(해지 후 다시 시작해도 같음)" },
      ],
      note: "결제 시작 전에 이 화면과 별도로 한 번 더 확인받습니다.",
    });
  }

  sections.push({
    id: "privacy",
    no: isCreator ? "④" : "③",
    title: "개인정보",
    chip: "방침 18개 장",
    list: [
      "내 정보 열람·정정·삭제·처리정지 요구 방법 — 설정 › 내 정보, contact@laeebly.com",
      isCreator ? "권리사에게 채널·영상·정산 수치 제공(작품 신청 때 동의) · 카카오 숏폼 프로그램 참가 정보 제공" : (isPartner ? "파트너님이 소개한 크리에이터의 개인 정보는 파트너님께 제공되지 않으며, 유입 집계치만 보입니다" : "협업 크리에이터의 채널·영상·정산 수치가 권리사 화면에 제공됨(크리에이터 동의 기반)"),
      "AI 도우미 레이 — 질문이 Anthropic(미국)에 전송되며 학습에 쓰지 않음",
      isCreator ? "등급 자동 산정·작품 추천은 자동화된 결정 — 설명 요구·수동 심사 가능" : "담당자 정보(이름·연락처·Google 계정)는 계약 이행 목적으로만",
      "주민등록번호는 정산 신청 때만, 소득세법에 따라 · 암호화 보관",
    ],
  });

  return sections;
}

export const LEGAL_NOTICE_LINKS = [
  { label: "전문 보기", path: "/terms-of-service" },
  { label: "무엇이 달라졌나", path: "/terms-of-service" },
  { label: "개인정보처리방침", path: "/privacy-policy" },
];
